export default {
    "/": "Image Me Souvenir Photography",
    "/about/santa": "Santa's Grotto Photography",
    "/about/ride": "Ride Photography",
    "/about/chromakey": "Green Screen Photography",
    "/about/keymatix": "KeyMatix",
    "/about/discrete": "Discrete Photo Solutions",
    "/about/payperclick": "Pay Per Click",
    "/about/printstation": "Print Station"
};